export enum DayObjectVariants {
  CHIP = 'CHIP',
  TILE = 'TILE',
}
